import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    leadSentence: { required },
    name: { required },
    verb: { required },
    verbAnswers: { required },
    audio: {
      fileUrl: {
        required,
      },
    },
    answers: {
      required,
      $each: {
        value: { required },
      },
    },
  },
  computed: {
    leadSentenceErrors() {
      const errors = [];
      if (!this.$v.leadSentence.$dirty) return errors;
      !this.$v.leadSentence.required &&
        errors.push("指示文を入力してください。");
      return errors;
    },
    nameErrors() {
      console.log("this.$v: ", this.$v);
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("問題文を入力してください。");
      return errors;
    },
    verbErrors() {
      const errors = [];
      if (!this.$v.verb.$dirty) return errors;
      !this.$v.verb.required && errors.push("動詞を入力してください。");
      return errors;
    },
    verbAnswersErrors() {
      const errors = [];
      if (!this.$v.verbAnswers.$dirty) return errors;
      !this.$v.verbAnswers.required && errors.push("回答を入力してください。");
      return errors;
    }
  },
};

export default mixin;
